import * as React from 'react';
import styles from './index.less';
import FComponentsLib from '@freelog/components-lib';
// import FSelect from '@/components/FSelect';
// import { Space } from 'antd';
import { FI18n } from '@freelog/tools-lib';
import FSelect2 from '@/components/FSelect2';

interface CollectionSettingProps {
  // setting 配置 https://freelog.yuque.com/org-wiki-freelog-qqxqll/gkva0w/rupov7xgdy5rxr50?inner=Q09Zp
  setting: {
    // collection_sorting: 'collection_sort_newest'
    //   | 'collection_sort_oldest'
    //   | 'collection_sort_title'
    //   | 'collection_sort_title_reverse'
    //   | 'collection_sort_manual'
    //   | 'collection_sort_manual_reverse',
    collection_sort_list: 'collection_sort_ascending' | 'collection_sort_descending';
    collection_item_title:
      | 'collection_item_title_rtitle'
      | 'collection_item_title_sn'
      | 'collection_item_title_empty'
      | 'collection_item_title_custom';
    collection_item_no_display:
      | 'collection_item_no_display_show'
      | 'collection_item_no_display_hide';
    collection_item_image_display:
      | 'collection_item_image_display_show'
      | 'collection_item_image_display_hide';
    collection_item_descr_display:
      | 'collection_item_descr_display_show'
      | 'collection_item_descr_display_hide';
    collection_view: 'collection_view_list' | 'collection_view_card';
  };

  // onChangeSort?(sort: 'collection_sort_newest'
  //   | 'collection_sort_oldest'
  //   | 'collection_sort_title'
  //   | 'collection_sort_title_reverse'
  //   | 'collection_sort_manual'
  //   | 'collection_sort_manual_reverse',
  // ): void;
  onChangeSort?(sort: 'collection_sort_ascending' | 'collection_sort_descending'): void;

  onChangeView?(view: 'collection_view_list' | 'collection_view_card'): void;

  onChange?(setting: CollectionSettingProps['setting']): void;

  onClose?(): void;
}

function CollectionSetting({
  setting,
  onChangeSort,
  onChangeView,
  onChange,
  onClose,
}: CollectionSettingProps) {
  return (
    <div className={styles.filter}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <FComponentsLib.FContentText
          type={'additional2'}
          // text={'浏览此合集的用户，将会看到你为合集中的单品设置的展示样式'}
          text={FI18n.i18nNext.t('cqr_itemmgmt_viewoptions_info')}
        />
        {/* <FComponentsLib.FTextBtn
          type={'primary'}
          style={{ fontSize: 12, lineHeight: '18px' }}
          onClick={() => {
            onClose?.();
          }}
        >
          收起
        </FComponentsLib.FTextBtn> */}
      </div>
      <div style={{ height: 20 }} />
      <div className={styles.filterItems}>
        <div style={{ flexBasis: 170 }}>
          <FComponentsLib.FContentText
            type={'additional2'}
            text={
              // '排序方式'
              FI18n.i18nNext.t('collection_sort_list')
            }
            style={{ fontWeight: 600, color: '#222' }}
          />
          <div style={{ height: 5 }} />
          <FSelect2
            value={setting.collection_sort_list || 'collection_sort_ascending'}
            options={[
              {
                value: 'collection_sort_ascending',
                label:
                  // '升序',
                  FI18n.i18nNext.t('collection_sort_ascending'),
              },
              {
                value: 'collection_sort_descending',
                // '降序',
                label: FI18n.i18nNext.t('collection_sort_descending'),
              },
            ]}
            style={{ width: '100%' }}
            onChange={(value) => {
              onChange?.({
                ...setting,
                collection_sort_list: value,
              });
              onChangeSort?.(value);
            }}
          />
        </div>

        <div style={{ flexBasis: 170 }}>
          <FComponentsLib.FContentText
            type={'additional2'}
            text={
              // '单品标题'
              FI18n.i18nNext.t('collection_item_title')
            }
            style={{ fontWeight: 600, color: '#222' }}
          />
          <div style={{ height: 5 }} />
          <FSelect2
            value={setting.collection_item_title}
            options={[
              {
                value: 'collection_item_title_rtitle',
                label:
                  // '显示为作品标题',
                  FI18n.i18nNext.t('collection_item_title_rtitle'),
              },
              {
                value: 'collection_item_title_sn',
                label:
                  // '显示为连载编号',
                  FI18n.i18nNext.t('collection_item_title_sn'),
              },
              {
                value: 'collection_item_title_custom',
                label:
                  // '自定义',
                  FI18n.i18nNext.t('collection_item_title_custom'),
              },
              {
                value: 'collection_item_title_empty',
                label:
                  // '不显示',
                  FI18n.i18nNext.t('collection_item_title_empty'),
              },
            ]}
            style={{ width: '100%' }}
            onChange={(value) => {
              onChange &&
                onChange({
                  ...setting,
                  collection_item_title: value,
                });
            }}
          />
        </div>

        <div style={{ flexBasis: 110 }}>
          <FComponentsLib.FContentText
            type={'additional2'}
            text={
              // '序号'
              FI18n.i18nNext.t('collection_item_no_display')
            }
            style={{ fontWeight: 600, color: '#222' }}
          />
          <div style={{ height: 5 }} />
          <FSelect2
            value={setting.collection_item_no_display}
            options={[
              {
                value: 'collection_item_no_display_show',
                label:
                  // '显示',
                  FI18n.i18nNext.t('collection_item_no_display_show'),
              },
              {
                value: 'collection_item_no_display_hide',
                label:
                  // '不显示',
                  FI18n.i18nNext.t('collection_item_no_display_hide'),
              },
            ]}
            style={{ width: '100%' }}
            onChange={(value) => {
              onChange &&
                onChange({
                  ...setting,
                  collection_item_no_display: value,
                });
            }}
          />
        </div>

        <div style={{ flexBasis: 110 }}>
          <FComponentsLib.FContentText
            type={'additional2'}
            text={
              // '单品封面'
              FI18n.i18nNext.t('collection_item_image_display')
            }
            style={{ fontWeight: 600, color: '#222' }}
          />
          <div style={{ height: 5 }} />
          <FSelect2
            value={setting.collection_item_image_display}
            options={[
              {
                value: 'collection_item_image_display_show',
                label:
                  // '显示',
                  FI18n.i18nNext.t('collection_item_image_display_show'),
              },
              {
                value: 'collection_item_image_display_hide',
                label:
                  // '不显示',
                  FI18n.i18nNext.t('collection_item_image_display_hide'),
              },
            ]}
            style={{ width: '100%' }}
            onChange={(value) => {
              onChange &&
                onChange({
                  ...setting,
                  collection_item_image_display: value,
                });
            }}
          />
        </div>

        <div style={{ flexBasis: 110 }}>
          <FComponentsLib.FContentText
            type={'additional2'}
            text={
              // '单品简介'
              FI18n.i18nNext.t('collection_item_descr_display')
            }
            style={{ fontWeight: 600, color: '#222' }}
          />
          <div style={{ height: 5 }} />
          <FSelect2
            value={setting.collection_item_descr_display}
            options={[
              {
                value: 'collection_item_descr_display_show',
                label:
                  // '显示',
                  FI18n.i18nNext.t('collection_item_descr_display_show'),
              },
              {
                value: 'collection_item_descr_display_hide',
                label:
                  // '不显示',
                  FI18n.i18nNext.t('collection_item_descr_display_hide'),
              },
            ]}
            style={{ width: '100%' }}
            onChange={(value) => {
              onChange &&
                onChange({
                  ...setting,
                  collection_item_descr_display: value,
                });
            }}
          />
        </div>

        <div style={{ flexBasis: 110 }}>
          <FComponentsLib.FContentText
            type={'additional2'}
            text={
              // '展示样式'
              FI18n.i18nNext.t('collection_view')
            }
            style={{ fontWeight: 600, color: '#222' }}
          />
          <div style={{ height: 5 }} />
          <FSelect2
            value={setting.collection_view}
            options={[
              {
                value: 'collection_view_list',
                label:
                  // '列表视图'
                  FI18n.i18nNext.t('collection_view_list'),
              },
              {
                value: 'collection_view_card',
                label:
                  // '卡片视图'
                  FI18n.i18nNext.t('collection_view_card'),
              },
            ]}
            style={{ width: '100%' }}
            onChange={(value: 'collection_view_list' | 'collection_view_card') => {
              onChange &&
                onChange({
                  ...setting,
                  collection_view: value,
                });
              onChangeView?.(value);
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default CollectionSetting;
